const formatCurrency = (value = 0) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);
};

const PayerSummaryTable = ({ data }) => {
  const rows = data?.data || [];

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-slate-900">
          Payer Summary — TIDAK FINAL
        </h2>
        <p className="text-sm text-slate-500">
          Rekap pemotong untuk dokumen TIDAK FINAL.
        </p>
      </div>

      {rows.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 p-8 text-center text-sm text-slate-500">
          No payer summary found.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="px-4 py-3 font-semibold">Payer</th>
                <th className="px-4 py-3 font-semibold">Docs</th>
                <th className="px-4 py-3 font-semibold">Gross Income</th>
                <th className="px-4 py-3 font-semibold">Net Income</th>
                <th className="px-4 py-3 font-semibold">Tax Withheld</th>
                <th className="px-4 py-3 font-semibold">Last Month</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr
                  key={`${row.payer_name}-${index}`}
                  className="border-t border-slate-100 hover:bg-slate-50/70"
                >
                  <td className="px-4 py-3 font-medium text-slate-900">
                    {row.payer_name}
                  </td>
                  <td className="px-4 py-3 text-slate-700">{row.docs_count}</td>
                  <td className="px-4 py-3 text-slate-700">
                    {formatCurrency(row.gross_income_total)}
                  </td>
                  <td className="px-4 py-3 text-slate-700">
                    {formatCurrency(row.net_income_total)}
                  </td>
                  <td className="px-4 py-3 text-slate-700">
                    {formatCurrency(row.tax_withheld_total)}
                  </td>
                  <td className="px-4 py-3 text-slate-700">{row.last_month}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

export default PayerSummaryTable;